import React, { useEffect } from "react";
import { DashboardsEmbedWrapper } from "./dashboardEmbed";
import { cookieAttributes } from "util/resumeCookieSettings";
import { Breadcrumbs } from "features/breadcrumb/breadcrumbs";
import { buildQueryBreadcrumbs } from "features/queryReports/utils/commonFunctions";
import classes from '../OpenQueryQueries/OpenQueryQueries.module.scss';

function QueryVizualizationReportPage(props) {
  const queryVisId = props?.match?.params?.jobId;

  const historyProps = props?.location?.state;
  const isDashboardQueryVis = historyProps?.dashboards;
  const queryVisName = isDashboardQueryVis ? historyProps?.dashboardName || '' : historyProps?.queryName || '';
  const dashboardDescription = isDashboardQueryVis ? historyProps?.dashboardDescription : 'An interactive QuickSight dashboard built from your requested query';
  const activeTab = historyProps?.activeTab || 'Shared';
  const activeTabName = activeTab === 'owned' ? 'My' : 'Shared';

  useEffect(() => {
    async function setResumeCookie() {
      const cookieValue = encodeURIComponent(`Query Visualization - /queryvisualization/${queryVisId}`);
      const resumeCookie = Object.assign(cookieAttributes(), { name: 'platform_resume' }, { value: cookieValue });
      await cookieStore.set(resumeCookie);
    }
    setResumeCookie();
  }, [queryVisId]);

  const breadCrumbsItems = isDashboardQueryVis
    ? [
      { label: "Home", to: "/" },
      { label: "Dashboards", to: "/dashboards" },
      { label: `${activeTabName} Dashboards`, to: `/dashboards/${activeTab}` },
      { label: `Visualize ${queryVisName}`, to: `/queryvisualization/${queryVisId}` }
    ]
    : buildQueryBreadcrumbs({
      customItems: [
        { label: "Home", to: "/" },
        { label: "Query", to: "/openquery" },
        { label: "My Queries", to: "/openquery/queries" },
        { label: `Visualize ${queryVisName}`, to: `/queryvisualization/${queryVisId}` }
      ]
    });

  return (
    <div className={`query-wrapper ${classes["create-query-wrapper"]}`}>
      <Breadcrumbs items={breadCrumbsItems} />
      <div className={classes["head-wrapper"]}>
        <h3 className={classes["heading"]}>Query Visualization {queryVisName}</h3>
        <span className={classes["subtitle"]}>
          {dashboardDescription}
        </span>
      </div>
      <div>
        {queryVisId && <DashboardsEmbedWrapper dashboardId={queryVisId} />}
      </div>
    </div>
  );
}

export default QueryVizualizationReportPage;